export const lang = {
	lang: 'English',
	lang1: 'Chinese',
	// lang: 'Chinese',
	// lang1: 'English',
	usersLogin: ' Users login',
	userName: 'User name',
	password: 'Password',

	// 公共
	footer1: 'Beijing hailanxin Data Technology Co., Ltd',
	footer2: 'security network security',
	home: "Home",
	information: 'Information announcement',
	about: 'About us',
	contact: 'Contact us',
	top: "ENTER ONLINE TRAINING SYSTEM",
	personalcenter: "Personal Center",
	logout: 'Log out',
	login: 'Login',

	// 提交验证
	check_name: "User name cannot be empty",
	check_email: "Mailbox cannot be empty",
	check_code: "Mailbox cannot be empty",
	check_password: "Password cannot be empty",
	check_password_: "Inconsistent passwords",
	check_realName: 'Real name cannot be empty',

	// 首页
	Checkcertificate: 'To verify the validity of the COC', // Check certificate
	Certificateauthenticityquery: "", //  Certificate authenticity query
	Clicktoenter: "Click to enter",
	Checkqualification: "To verify the validity of service engineer & company certificate",
	Service: '',
	Applyforcertificate: 'Apply for COC',
	Customs: " ",
	Companyprofile: 'Company profile',
	Learnmore: 'Learn more',
	txt: "The company's business scope covers a variety of ship types in the field of navigation, such as merchant ships, marine special ships, official ships, fishing boats and ships, as well as physical ocean, marine surveying and mapping, underwater engineering, seabed observation, marine unmanned system, sea area management, etc. in the field of marine informatization.",

	// 信息公告详情
	Relevantannouncements: 'Relevant announcements',
	Last: 'Last',
	Next: "Next",

	// 公司简介
	Companyprofile: 'Company profile',
	abouttext1: 'Founded in 2001, Hisense was listed on Shenzhen Stock Exchange on March 26, 2010. Headquartered in Beijing environmental protection science and Technology Park, the company has branches in Hainan Sansha, Guangdong, Shanghai and other places, and branches and R & D centers in Germany, Singapore, Russia, Canada and other places. Following the R & D concept of "independent R & D as the basis and international cooperation to create first-class", Hisense has gathered an international R & D team of more than 200 people and has nearly 100 patents and software copyrights. In 2020, the total number of the group will exceed 600, with an output value of 1 billion yuan.',
	abouttext2: "The company's business scope covers a variety of ship types in the field of navigation, such as merchant ships, marine special ships, official ships, fishing boats and ships, as well as physical ocean, marine surveying and mapping, underwater engineering, seabed observation, marine unmanned system, sea area management, etc. in the field of marine informatization. The company has always been a supplier of government agencies in relevant fields, providing such customers with products and services such as integrated navigation system and monitoring and management system based on ship end and shore based to the sea. At the same time, the company serves civil fields such as ocean transportation, marine engineering, marine scientific investigation, marine environment and marine fishery, and provides customers with products and services such as integrated navigation, marine information and monitoring management.",
	abouttext3: "The company's Maritime + ocean comprehensive sea business model can provide customers with ship navigation intelligent system solutions, shore based and ship / ship based sea monitoring and management services, and build a sea air space integration marine monitoring network and marine information data platform combining nearshore + offshore + medium and high seas and surface + underwater, which can provide services for sea area use management, marine environmental protection, marine resource exploration, development and utilization Provide effective data and decision-making information for marine law enforcement and supervision.",

	// 关于我们
	Office1: "Guangzhou Office",
	Office2: "Shanghai Office",
	Office3: "Wuhan Office",
	Office4: "Nantong Office",
	Office5: "Hainan Office",
	hotline: 'Service hotline',
	mailbox: 'mailbox',
	address: 'address',
	address1: '6 / F, Dibao building, No. 62, Jianzhong Road, Tianhe Software Park, Tianhe District, Guangzhou',
	address2: 'Room 301, building 7, No. 777, Longwu Road, Xuhui District, Shanghai',
	address3: '8th floor, No. T5, Guocai Center office building, Guanggu 6th Road, Gaoxin Avenue, Donghu high tech Zone, Wuhan',
	address4: '199 Qingfeng Road, Chongzhou District, Nantong City, Jiangsu Province',
	address5: 'Room 2207 and 2208, block C, Guorui building, Guoxing Avenue, Haikou City, Hainan Province',

	// 查证书
	inspectioncertificate: ' Enter the COC number',
	COCcertificatenumber: "",
	Startquery: "Start query",
	Thetestresultsareasfollows: "The test results are as follows",
	Thecertificateistestedtobetrueandvalid: "The certificate is tested to be true and valid!",
	Thecertificatedoesnotexist: "The certificate does not exist!",
	mattersneedingattention: "matters needing attention",
	certinficatetxt1: "After querying the DV COC certificate for domain name verification, the company name will be blank.",
	certinficatetxt2: "Check the COC certificate issued by yourself. It is normal that the certificate chain information is incomplete. For the safety of your website, you'd better upgrade to the authoritative COC Certificate in time!",
	certinficatetxt3: "Ghana CTN is a commodity exported by China to West African countries. You must apply for the number of electronic goods locally and display it on the bill of lading. If there is no Ghana CTN, you will be fined. In other words, it is equivalent to the express order number. These countries, including Ghana Tema, Accra, Kumasi and takrady, must apply for Ghana CTN. According to Ghana decree of Ghana, from March 1, 2018, all goods delivered to Ghana Tema, Accra, Kumasi, takrady and tamali must apply for CTN (cargo tracking notes) number from zktest. Failure to apply for this bill of lading will be regarded as a violation of Ghana's regulations and will be severely punished at the port of destination.",
	Quickentrance: "Quick entrance",

	// 查资质
	qualification1: 'Service company and engineer certificate authenticity inquiry',
	qualification2: 'Enter the certificate number',

	// 证书申请
	CertificateApplication: " Certificate Application",
	applytit1: "VDR device information",
	applytit2: "Basic ship information",
	applytit3: "Company information",
	applytit4: "Upload attachment data",
	nextstep: "next step",
	Previousstep: "Previous step",
	ConfirmSubmission: "Confirm",
	Fail: "Fail",
	apply1: {
		tit1: "VDR serial number",
		tit2: "VDR Model",
		tit3: "PDC serial number",
		tit4: "Beacon serial number",
		tit5: "Beacon expired data",
		tit6: "FFC serial number",
		tit7: "FFC battery expired data",
		tit8: "HRU expired data",
		tit9: "VRD backup battery expired data",
		tit10: "VDR software version",
	},
	apply2: {
		tit1: "Vessel Name",
		tit2: "Contact email",
		tit3: "Ship Owner",
		tit4: "Contact number",
		tit5: "FLAG",
		tit6: "CLASS",
	},
	apply3: {
		tit1: "Name of inspection company",
		tit2: "Email address of inspection company",
		tit3: "Certificate No. of inspection company",
		tit4: "Name of Inspection Engineer",
		tit5: "certificate of inspect engineer",
		tit6: "Certificate No. of Class",
		tit7: "The data of inspect",
		tit8: "The place of inspect",
	},
	apply4: {
		tit1: "Material name",
		tit2: "Attachment name",
		tit3: "operation",
		uploadFile: "uploadFile",
		name1: '01. VDR configuration file',
		name2: '02. Highlander APT FORM',
		name3: '03. Class Form',
		name4: '04. FFC test report',
		name5: '05. PDC data (5 minutes)',
		name6: '06. FFC data (5 minutes)',
		name7: '07. LRU data (5 minutes)',
		name8: '08. Log',
		name9: '09. Engineer Certificate',
		name10: '10. Service Report',
		name11: '11. MU Photos with serial number',
		name12: '12. PDC photos',
		name13: '13、FFC photos',
		name14: '14、OPU photos',
		txt1: "(Validity period of backup battery)",
		txt2: "(PDC Serial number、PDC junction box、Beacon serial number、Beacon validity)",
		txt3: "(FFC Serial number、FFC junction box、FFC Information、Period of validity mark paste)",
	},

	// 个人中心
	PersonalCenter: 'Personal Center',
	Personal: {
		Basicinformation: "Basic information",
		Auditlist: "Audit list",
		Mycertificate: "My certificate",
		ChangePassword: "Change Password",
		ReturntoPersonalCenter: "Return to personal center",
		headportrait: "Change head portrait",
		Realname: "Real name",
		Company: "Company",
		Enterprisemailbox: "Enterprise mailbox",
		Registrationtime: "Registration time",
		LastIPaddress: "Last IP address",
		Lastlogin: "Last login",
		OldPassword: "Old  password：",
		NewPassword: "New password：",
		ConfirmPassword: "Confirm password：",
		VerificationCode: "Verification Code：",
		preservation: "preservation",
		title: "shipName",
		Applicationtime: "Application time",
		applicant: 'applicant',
		Auditstatus: "Audit status",
		operation: "operation",
		Underreview: "To audit",
		Approved: "Approved",
		Auditfailed: "Audit failed",
		PendingSubmission: "Pending Submission",
		revoke: "revoke",
		Viewdetails: "View details",
		Reapply: "Reapply",
		back: 'back',
		essentialinformation: 'Essential information',
		Email: "email",
		get_vCode: "Send Code",
		delete: "delete",
		search: "search"
	},
	audit: {
		name1: "Ship name",
		name2: "VDR serial number",
		name3: "VDR Type number",
		name4: 'Software version',
		name5: "PDC serial number",
		name6: "PDC Type number",
		name7: "FFC serial number",
		name8: "FFC Type number",
		name9: "Beacon serial number",
		name10: "Beacon Type number",
		name11: "Beacon validity",
		name12: "FFC battery serial number",
		name13: "FFC battery Type number",
		name14: "Validity period of FFC battery",
		name15: "Hydrostatic pressure release type number",
		name16: "term of validity",
		name17: "Validity period of backup battery",
		name18: "Name of inspection company",
		name19: "Qualification Certificate No",
		name20: "Name of Inspection Engineer",
		name21: "Qualification Certificate No",
		name22: "Inspection date",
		name23: "Inspection location",
		name24: "Certificate No",
		name25: "Certificate validity",
		name26: "Under review, please wait patiently",
		name27: "Audit information",
		name28: "Auditor name",
		name29: "Audit conclusion",
	},
	certificate: {
		MyCertificate: "My certificate",
		Certificatename: "Certificate name",
		CertificateNo: "Certificate No",
		Gettime: "Get time",
		Termvalidity: "Term of validity",
		operation: "operation",
		ViewCertificate: "View Certificate",
		China: "CHINA",
		TheDownloadfile: "The download file"
	},
	customer_cert_1: 'Engineer certificate',
	customer_cert_2: 'Company certificate'
}
